<template>
  <div>
    <v-alert
      v-for="(msg, index) in messages"
      :key="index"
      :type="msg.type"
      :dismissible="msg.dismissible"
    >
      {{ msg.text }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "MessageContainer",
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="sass"></style>
